/**
 * SecuritySearch Modal component module.
 * @module advisor/components/modals/SecuritySearch
 *
 */
// TODO PENDING REQS
//  Do not search if no search term provided? yes
//  Do not gather data on initial load? yes
//  No results yet (IN PLACE OF THE TABLE?) see v2 validSearch
//    "Type above to search for securities"
//    "No Securities Found"
//  SELECTION PANEL
//    "No Securities Selected"
//    Sorting?
//    Is there a need for a dataManager.toggleRowSelected?
//  Restricted broken on backend? No?

import React, {useState} from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import PropTypes from 'prop-types';
import debug from 'debug';
import {Button, Table} from '../../../index';
import Row from '../../Row';
import {gatherData} from '../../../utils/utils';

const log = debug('circleblack:advisor:modals:security-search');
const gatherSecurities = gatherData('/securities');

/**
 * Security Search component
 * @name SecuritySearch
 */
const SecuritySearch = props => {
  const {content, openModal, removeModal} = props;
  const {onAddSecurities, filters = {}, restricted} = content;
  const [selectedRows, setSelectedRows] = useState([]);

  const dataManager = {
    gatherData: inputValue => {
      if (inputValue.hasOwnProperty('identifierValue')) {
        inputValue.identifierType = 6;
      }

      if (restricted && !Object.keys(filters).length) {
        inputValue.restricted = 1;
      }

      return gatherSecurities({
        ...filters,
        ...inputValue,
        limit: 50,
      })
        .catch(function error(err) {
          log('error', err);
          openModal({
            type: 'MessageModal',
            title: 'Search Option Error',
            body: 'There was an error while searching securities.',
          });
        });
    },
    setSelectedRows: setSelectedRows,
  };

  const addSecurities = securities => {
    onAddSecurities(securities);
    removeModal(content);
  };

  log('rendering');
  return <BaseModal onClose={() => removeModal(content)} title={'Security Search'} size={'lg'}>
    <Row wrap={false}>
      <Button importance={'secondary'}
              size={'md'}
              label={'Cancel'}
              action={() => {removeModal(content);}}/>
      {/*TODO PENDING REQS remove these? How will we open the selection panel?*/}
      {/*<Button importance={'secondary'}*/}
      {/*        size={'md'}*/}
      {/*        label={`View Selected (${selectedRows.length})`}*/}
      {/*  // disabled={!model.title || allocated.total!=100}*/}
      {/*  //       action={() => setView('view')}*/}
      {/*/>*/}
      {/*<Button importance={'secondary'}*/}
      {/*        size={'md'}*/}
      {/*        label={`Edit Selection (${selectedRows.length})`}*/}
      {/*  // disabled={!model.title || allocated.total!=100}*/}
      {/*  //       action={() => setView('add')}*/}
      {/*/>*/}
      <Button importance={'primary'}
              size={'md'}
              label={'Add Securities'}
              disabled={!selectedRows.length}
              action={() => {addSecurities(selectedRows);}}/>
    </Row>
    <Table dataManager={dataManager}
           columns={[
             {
               title: 'Security Name',
               dataPoint: 'name',
               type: 'text',
               minWidth: 50,
               isSortable: false,
             },
             {
               title: 'Symbol',
               dataPoint: 'ticker',
               type: 'text',
               minWidth: 50,
               isSortable: false,
             },
           ]}
           defaultSort={{
             column: 'name',
             desc: false,
           }}
           searches={[
             {
               title: 'All',
               name: 'q',
               isFuzzy: false,
             },
             {
               title: 'Security Name',
               name: 'name',
               isFuzzy: false,
             },
             {
               title: 'Symbol',
               name: 'identifierValue',
               isFuzzy: false,
             },
           ]}
           select={{
             max: 100,
           }}
           rowIdentifier={'id'}
           height={'500px'}/>
  </BaseModal>;
};

const mapDispatchToProps = dispatch => ({
  removeModal: modalToRemove => dispatch(_removeModal(modalToRemove)),
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});
export default connect(null, mapDispatchToProps)(SecuritySearch);

SecuritySearch.propTypes = {
  openModal: PropTypes.func.isRequired,
  removeModal: PropTypes.func.isRequired,
  content: PropTypes.shape({
    /**
     * Function to execute upon pressing the Add Securities button
     */
    onAddSecurities: PropTypes.func.isRequired,
    /**
     * Filters to pass to the security search whenever it gathers data
     */
    filters: PropTypes.object,
    /**
     * Whether the universe of securities should be "restricted"
     */
    restricted: PropTypes.bool,
  }),
};
